import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between" }
const _hoisted_2 = { class: "w-full flex-grow flex flex-col justify-center" }
const _hoisted_3 = { class: " text-left flex flex-wrap flex-col py-8 mx-5 mb-3 mt-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Qual é o texto deste versículo? ")
const _hoisted_5 = {
  class: "select-none text-2xl font-bold w-full text-white",
  "data-testid": "question-title"
}
const _hoisted_6 = {
  id: "alternatives",
  class: "p-5 flex flex-wrap content-center justify-between rounded-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_label = _resolveComponent("question-label")
  const _component_blue_button = _resolveComponent("blue-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_question_label, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.question.title), 1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.question.alternatives, (alternative) => {
        return (_openBlock(), _createBlock(_component_blue_button, {
          key: alternative,
          "data-testid": alternative,
          "show-result": _ctx.showResults,
          "is-correct": alternative === _ctx.question.rightAlternative,
          class: "text-left px-2 py-3 text-white bg-gray-100 bg-opacity-20 w-full text-md",
          onClick: ($event: any) => (_ctx.onSelect(alternative, _ctx.question.rightAlternative))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(alternative), 1)
          ]),
          _: 2
        }, 1032, ["data-testid", "show-result", "is-correct", "onClick"]))
      }), 128))
    ])
  ]))
}